export default __webpack_public_path__ + "static/media/baner.24c57c39.jpg";